import { render, staticRenderFns } from "./listCustomersSellers.vue?vue&type=template&id=cf5ff4f2&scoped=true"
import script from "./listCustomersSellers.vue?vue&type=script&lang=js"
export * from "./listCustomersSellers.vue?vue&type=script&lang=js"
import style0 from "./listCustomersSellers.vue?vue&type=style&index=0&id=cf5ff4f2&prod&lang=css"
import style1 from "./listCustomersSellers.vue?vue&type=style&index=1&id=cf5ff4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5ff4f2",
  null
  
)

export default component.exports